import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

export default function LoginPage() {
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const quizCode = params.get("quiz");

  useEffect(() => {
    if (!quizCode) {
      alert("Quiz link missing! Please use quiz link from admin.");
      navigate("/");
    }
  }, [quizCode, navigate]);

  useEffect(() => {
    // read quiz code from URL
    const params = new URLSearchParams(window.location.search);
    const quizCode = params.get("quiz");

    if (quizCode) {
      sessionStorage.setItem("quiz_code", quizCode);
    }
  }, []);

  const handleLogin = () => {
    if (!name.trim()) {
      setError("Please enter Mobile No / Name");
      return;
    }

    const quizCode = sessionStorage.getItem("quiz_code");
    if (!quizCode) {
      setError("Invalid Quiz Link! Please open quiz link shared by admin.");
      return;
    }

    sessionStorage.setItem("user", name);
    navigate("/quiz");
  };

  return (
    <div className="container-fluid min-vh-100 d-flex justify-content-center align-items-center bg-light">
      <div className="row w-100 justify-content-center">
        <div className="col-11 col-sm-8 col-md-6 col-lg-4">
          <div className="card shadow-lg border-0 rounded-4">
            <div className="card-body p-4 p-md-5">
              <div className="text-center mb-4">
                <div
                  className="rounded-circle bg-primary text-white d-inline-flex align-items-center justify-content-center mb-3"
                  style={{ width: 60, height: 60, fontSize: 24 }}
                >
                  📝
                </div>
                <h3 className="fw-bold mb-1">Student Login</h3>
                <p className="text-muted mb-0">Enter your name & start quiz</p>
              </div>

              <div className="mb-3">
                <label className="form-label fw-semibold">
                  Mobile No / Name
                </label>
                <input
                  type="text"
                  className={`form-control form-control-lg rounded-3 ${
                    error ? "is-invalid" : ""
                  }`}
                  placeholder="Enter your mobile or name"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    setError("");
                  }}
                  onKeyDown={(e) => e.key === "Enter" && handleLogin()}
                />
                {error && <div className="invalid-feedback">{error}</div>}
              </div>

              <button
                className="btn btn-primary btn-lg w-100 rounded-3 fw-semibold"
                onClick={handleLogin}
              >
                Login & Start Quiz 🚀
              </button>

              <div className="text-center mt-4">
                <small className="text-muted">
                  Your data will not be stored after quit.
                </small>
              </div>
            </div>
          </div>

          <div className="text-center mt-3">
            <small className="text-secondary">
              Admin?{" "}
              <a href="/admin-login" className="text-decoration-none">
                Go to Admin Login
              </a>
            </small>
          </div>
        </div>
      </div>
    </div>
  );
}
